// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0

import { OryCardContentProps } from "@ory/elements-react"

export function DefaultCardContent({ children }: OryCardContentProps) {
  return children
}
